// extracted by mini-css-extract-plugin
module.exports = {"qualityGaugeWrapper":"TB2R8ja_","qualityGaugeBackground":"Kb62gsS0","gaugeVerdictWrapper":"OB9w_jSB","gaugeVerdict":"FEn9Loow","gaugeArrow":"rzo7YqmZ"};